import React, {useEffect, useState} from 'react';
import { Form, Input, Button, Card, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useGlobal } from '../../System/Global/GlobalProvider';
import { useNavigate, useParams } from 'react-router-dom';

const AutoLogin = () => {

    const navigate = useNavigate();
    const { autoauthenticate } = useGlobal();

    const { userKey } = useParams(); 

    useEffect(() => {

        console.log('userKey', userKey)

        // localStorage.setItem(`clients.opex-cluId`, userKey);

        auth();


    }, []);

    const auth = async () => {

        if (await autoauthenticate(userKey)) {
            navigate('/bookings/Delivered');
        }

    }


    return (
        <div></div>
    )
}

export default AutoLogin;
